import React, {ReactNode} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

type Props = {
    children?: ReactNode;
    border?: boolean;
};

export const Footer = ({children, border}: Props) => {
    return <div className={cx(styles.footer, {[styles.border]: border})}>{children}</div>;
};
